import React from "react";
import PropTypes from "prop-types";
import mainStore from "../../../../../stores/main";
var StepLearnMore = function StepLearnMore(_ref) {
  var isDesktop = _ref.isDesktop,
    content = _ref.content,
    learnMore = _ref.learnMore,
    showLearnMore = _ref.showLearnMore;
  var description = /*#__PURE__*/React.createElement("p", {
    className: "step__learn-more__description",
    dangerouslySetInnerHTML: {
      __html: content.Body
    }
  });
  var desktopLayout = /*#__PURE__*/React.createElement("p", {
    className: "step__learn-more"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold",
    dangerouslySetInnerHTML: {
      __html: "".concat(mainStore.dictionary.Quiz.learnMore, ": ")
    }
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: content.Body
    }
  }));
  var mobileLayout = /*#__PURE__*/React.createElement("div", {
    className: "step__learn-more"
  }, /*#__PURE__*/React.createElement("button", {
    className: "step__learn-more__button like-white-blue-button ".concat(learnMore ? "active" : ""),
    onClick: function onClick(e) {
      e.preventDefault();
      showLearnMore();
    },
    dangerouslySetInnerHTML: {
      __html: mainStore.dictionary.Quiz.learnMore
    }
  }), learnMore ? description : "");
  if (isDesktop) {
    return desktopLayout;
  }
  return mobileLayout;
};
export default StepLearnMore;
StepLearnMore.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  learnMore: PropTypes.bool.isRequired,
  showLearnMore: PropTypes.func.isRequired
};